export default __webpack_public_path__ + "static/media/shape2.2a60531c.svg";